import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { SuperAdminService } from "src/app/super-admin.service";

@Component({
  selector: "app-date-wise-lr-expense",
  templateUrl: "./date-wise-lr-expense.component.html",
  styleUrls: ["./date-wise-lr-expense.component.css"],
})
export class DateWiseLrExpenseComponent implements OnInit {
  LrExpenseArray: any[] = [];
  paramMonthShort: string;
  paramCompanyId: string;
  paramSupervisorId: string;
  year: number;
  type: "LR" | "Tracker" = "LR";
  monthNumber: number;
  month: string;
  monthArr: string[] = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
  ];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private superadminService: SuperAdminService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {

    this.activatedRoute.params.subscribe((param) => {
      this.paramMonthShort = param.id;
      this.paramCompanyId = param.company;
      this.paramSupervisorId = param.supervisor;
      this.year = +param.year;

      this.monthNumber = this.monthArr.indexOf(this.paramMonthShort) + 1;
      this.month = this.monthArr[this.monthNumber - 1];
    });

    this.activatedRoute.queryParams.subscribe((query) => {
      this.type = query.type === "Tracker" ? "Tracker" : "LR";
    });

    this.getExpense();
  }

  getExpense() {
    if (
      !this.monthNumber ||
      !this.paramCompanyId ||
      !this.paramSupervisorId
    ) {
      this.toastr.error("Invalid route parameters");
      return;
    }

    this.spinner.show();

    this.superadminService
      .getLRsBySupervisorCompanyMonth(
        this.paramSupervisorId,
        this.paramCompanyId,
        this.monthNumber,
        this.year,
        this.type
      )
      .subscribe(
        (res: any) => {
          if (res.status === true) {
            this.LrExpenseArray = res.data;
          } else {
            this.toastr.error(res.message);
          }
          this.spinner.hide();
        },
        () => {
          this.spinner.hide();
          this.toastr.error("Failed to load details");
        }
      );
  }

  backTo() {
    window.history.back();
  }
}
